const initialState = {
  counter: 10,
  personalInfo: {
    name: "",
    iAm: "",
    aboutMe: "",
    height: "4.5",
    weight: "",
    profileImage: "",
    bloodGroup: "",
    complextion: "",
    maritalStatus: "",
    hobbies: "",
    aboutMyFamily: "",
    bodyType: "",
    eyeWear: "",
  },
  birthDetails: {
    dob: {
      date: "",
      placeOfBirth: "",
      age: "",
      time: "",
      day: "",
    },
    tamilYear: "",
    tamilMonth: "",
    tamilDate: "",
  },
  residentialAddress: {
    address: "",
    landmark: "",
    hometown: "",
    city: "",
    stateName: "",
    nationality: "",
    pincode: "",
  },
  qualification: [
    {
      fieldOfStudy: "",
      degree: "",
      currentlyPursuing: false,
    },
  ],
  occupation: {
    companyName: "",
    designation: "",
    annualIncome: "",
    cityOfWorking: "",
  },
  horoscopeDetails: {
    rasi: "",
    nakshatra: "",
    padham: "",
    gothram: "",
    mathulam: "",
    lagnam: "",
    naaligai: "",
    thithi: "",
    dasaPlanet: "",
    dasaBalance: "",
    god: "",
    raguDosham: "",
    chevaiDosham: "",
    horoscopeHints: "",
  },
  familyDetails: {
    fatherName: "",
    fatherOccupation: "",
    fatherEducation: "",
    fatherAlive: "",
    motherName: "",
    motherOccupation: "",
    motherEducation: "",
    motherAlive: "",
    religion: "",
    caste: "",
    familyStatus: "",
    siblings: {
      brother: {
        number: "",
        marriageNum: "",
      },
      sister: {
        number: "",
        marriageNum: "",
      },
    },
  },
  horoscopeImage: "",
  govtId: "",
  lookingFor: "",
  createdBy: "",
  startDate: "",
  contactDetails: {
    emailId: "",
    contactNumber: "",
    whatsappNumber: "",
    alternativeContactNumber: "",
  },
  rasiKatam: [[], [], [], [], [], [], [], [], [], [], [], []],
  rasiPlanets: {
    Ma: "Select",
    Ve: "Select",
    Me: "Select",
    Su: "Select",
    Ka: "Select",
    Ju: "Select",
    Mo: "Select",
    Sa: "Select",
    Ke: "Select",
    La: "Select",
    Ra: "Select",
  },
  navamsaKatam: [[], [], [], [], [], [], [], [], [], [], [], []],
  navamsaPlanets: {
    Ma: "Select",
    Ve: "Select",
    Me: "Select",
    Su: "Select",
    Ka: "Select",
    Ju: "Select",
    Mo: "Select",
    Sa: "Select",
    Ke: "Select",
    La: "Select",
    Ra: "Select",
  },
  ownHouse: "Yes",
  verificationDetails: {
    emailVerificationDetails: {
      status: "",
      message: "",
    },
    mobileVerificationDetails: {
      status: "",
      message: "",
    },
    govtIdVerificationDetails: {
      status: "",
      message: "",
    },
  },
  eatingHabits: "",
  drinkingHabits: "",
  smokingHabits: "",
  propertyDetails: "",
  otherIncome: "",
  // profileStatus: "",
  isProfileFetched: false,
  isFormChanged: false,
};

export default initialState;
